/* eslint-disable global-require */

/* eslint-disable import/prefer-default-export */
export const Images = {
  Promo: require('../assets/images/promo-login.svg').default,
  RotateVector: require('../assets/images/rotatevector.svg').default,
  AccountLinkSuccess: require('../assets/images/accountlinksuccess.svg')
    .default,
  AccountLinkReject: require('../assets/images/accountstatusreject.svg')
    .default,
  RotateVector2: require('../assets/images/rotatevector2.svg').default,
  Bulb: require('../assets/images/stepstoimport.svg').default,
  CSV: require('../assets/images/csv.svg').default,
  SHIcon: require('../assets/images/sh-logo-icon.svg').default,
  SHIcon70: require('../assets/images/sh-logo-icon-70x70.svg').default,
  SHLogoSmall: require('../assets/images/sh-logo.svg').default,
  SHLogo: require('../assets/images/saleshandy-logo.svg').default,
  SHLogoIcon: require('../assets/images/saleshandy-logo-icon.svg').default,
  SHLogoText: require('../assets/images/saleshandy-logo-text.svg').default,
  SHLogoWithText: require('../assets/images/logo-with-name.svg').default,
  GoogleLogin: require('../assets/images/google-login.svg').default,
  FileCheck: require('../assets/images/file-check.svg').default,
  GoogleIcon: require('../assets/images/google-icon.svg').default,
  // GmailIcon: require('../assets/images/gmail-icon.svg').default,
  MicrosoftLogin: require('../assets/images/microsoft-login.svg').default,
  MicrosoftIcon: require('../assets/images/microsoft-logo.svg').default,
  MicrosoftIconSmall: require('../assets/images/microsoft-logo-small.svg')
    .default,
  AzureIconSmall: require('../assets/images/azure-icon-small.svg').default,
  BrokenLink: require('../assets/images/broken-link.svg').default,
  EmptyData1: require('../assets/images/empty-data-1.svg').default,
  EmptyData2: require('../assets/images/empty-data-2.svg').default,
  EmptyData3: require('../assets/images/empty-data-3.svg').default,
  EmptyData4: require('../assets/images/empty-data-4.svg').default,
  EmptyData5: require('../assets/images/empty-data-5.svg').default,
  EmptyData6: require('../assets/images/empty-data-6.svg').default,
  EmptyData7: require('../assets/images/empty-data-7.svg').default,
  Squiggles: require('../assets/images/squiggles.svg').default,
  StepTypeEmail: require('../assets/images/sequence/step-type-email.svg')
    .default,
  PersonMonocular: require('../assets/images/person-monocular.svg').default,
  NeptikLogo: require('../assets/images/customers/neptik-logo.svg').default,
  // NeptikLogoBlack: require('../assets/images/customers/neptik-logo-black.svg')
  //   .default,
  MaropostLogo: require('../assets/images/customers/maropost-logo.svg').default,
  KelltonLogo: require('../assets/images/customers/kellton-logo.svg').default,
  DigitalRafterLogo: require('../assets/images/customers/digital-rafter-logo.svg')
    .default,
  YelpLogo: require('../assets/images/customers/yelp-logo.svg').default,
  // CloudtalkLogo: require('../assets/images/customers/cloudtalk-logo.svg')
  //   .default,
  // DorikLogo: require('../assets/images/customers/dorik-logo.svg').default,
  GoDaddyLogo: require('../assets/images/customers/godaddy-logo.svg').default,
  // IntegratelyLogo: require('../assets/images/customers/integrately-logo.svg')
  //   .default,
  // OpslyftLogo: require('../assets/images/customers/opslyft-logo.svg').default,
  // RevvixLogo: require('../assets/images/customers/revvix-logo.svg').default,
  // VrooziLogo: require('../assets/images/customers/vroozi-logo.svg').default,
  DoctorLogo: require('../assets/images/vector-doctor.svg').default,
  FilterLogo: require('../assets/images/vector-filter.svg').default,
  MailActive: require('../assets/images/sh-call-active.svg').default,
  MailDisabled: require('../assets/images/mail-disabled.svg').default,
  NoSearchResultIcon: require('../assets/images/no-search-result-icon.svg')
    .default,
  NoSearchResultSavedIcon: require('../assets/images/no-search-result-saved-icon.svg')
    .default,
  MailEnabled: require('../assets/images/mail-enable.svg').default,
  EyeActive: require('../assets/images/sh-eye-active.svg').default,
  EyeDisabled: require('../assets/images/sh-eye-disabled.svg').default,
  ReplyActive: require('../assets/images/sh-reply-active.svg').default,
  ReplyDisabled: require('../assets/images/sh-reply-disabled.svg').default,
  LinkActive: require('../assets/images/sh-link-active.svg').default,
  LinkActive2: require('../assets/images/link-enable-2.svg').default,
  LinkDisabled: require('../assets/images/sh-link-disabled.svg').default,
  LinkDisabled2: require('../assets/images/link-disable-2.svg').default,
  ProspectActivityEmailSent: require('../assets/images/email-sent.svg').default,
  ProspectActivityEmailSentBlue: require('../assets/images/email-sent-blue.svg')
    .default,
  EngagementActivityAllTab: require('../assets/images/tab-all.svg').default,
  EngagementActivityAllTabBlue: require('../assets/images/tab-all-blue.svg')
    .default,
  EngagementActivityOpenedTab: require('../assets/images/tab-opened.svg')
    .default,
  EngagementActivityOpenedTabBlue: require('../assets/images/tab-opened-blue.svg')
    .default,
  EngagementActivityClickedTab: require('../assets/images/tab-clicked.svg')
    .default,
  EngagementActivityClickedTabBlue: require('../assets/images/tab-clicked-blue.svg')
    .default,
  EngagementActivityRepliedTab: require('../assets/images/tab-replied.svg')
    .default,
  EngagementActivityRepliedTabBlue: require('../assets/images/tab-replied-blue.svg')
    .default,
  ProspectActivityEmailSentColored: require('../assets/images/email-sent-colored.svg')
    .default,
  ProspectActivityLinkClicked: require('../assets/images/link-clicked.svg')
    .default,
  ProspectActivityLinkClickedColored: require('../assets/images/link-clicked-colored.svg')
    .default,
  ProspectActivityEmailBounced: require('../assets/images/mail-bounced.svg')
    .default,
  ProspectActivityEmailBouncedColored: require('../assets/images/mail-bounced-colored.svg')
    .default,
  ProspectActivityEmailFailed: require('../assets/images/mail-failed.svg')
    .default,
  ProspectActivityEmailFailedColored: require('../assets/images/mail-failed-colored.svg')
    .default,
  ProspectActivityEmailOpened: require('../assets/images/mail-opened.svg')
    .default,
  ProspectActivityEmailOpenedColored: require('../assets/images/mail-opened-colored.svg')
    .default,
  ProspectActivityEmailReceived: require('../assets/images/reply-received.svg')
    .default,
  ProspectActivityEmailReceivedColored: require('../assets/images/reply-received-colored.svg')
    .default,
  ProspectActivityEmailUnsubscribed: require('../assets/images/email-unsubscribed.svg')
    .default,
  ProspectActivityEmailUnsubscribedColored: require('../assets/images/unsubscribed-colored.svg')
    .default,
  Shield: require('../assets/images/sh-shield.svg').default,
  SentEmail: require('../assets/images/send.svg').default,
  SentEmailLarge: require('../assets/images/send-email-l.svg').default,
  SentEmailBlue: require('../assets/images/sent-email-blue.svg').default,
  SentEmailBlueXL: require('../assets/images/email-sent-blue-xl.svg').default,
  SeenEmail: require('../assets/images/activeseen.svg').default,
  SeenEmailCyan: require('../assets/images/seen-email-cyan.svg').default,
  WarningTriangle: require('../assets/images/alert-triangle-warning.svg')
    .default,
  AlertTriangle: require('../assets/images/alert-triangle.svg').default,
  AlertTriangleRed: require('../assets/images/alert-triangle-red.svg').default,
  AlertTriangleLarge: require('../assets/images/alert-triangle-xl.svg').default,
  Clock: require('../assets/images/clock.svg').default,
  ClockYl: require('../assets/images/clock-yellow.svg').default,
  Tag: require('../assets/images/tag.svg').default,
  GreyTag: require('../assets/images/tag-grey.svg').default,
  TagBlue: require('../assets/images/tag-blue.svg').default,
  TagBlueXL: require('../assets/images/tag-blue-xl.svg').default,
  Forward: require('../assets/images/forward.svg').default,
  Backward: require('../assets/images/backward.svg').default,
  Close: require('../assets/images/close.svg').default,
  Wallet: require('../assets/images/wallet.svg').default,
  Ban: require('../assets/images/ban.svg').default,
  BanBlueXL: require('../assets/images/ban-blue-xl.svg').default,
  Trash: require('../assets/images/trash.svg').default,
  TrashLight: require('../assets/images/trash-light.svg').default,
  TrashBlueXL: require('../assets/images/trash-blue-xl.svg').default,
  TrashDanger: require('../assets/images/trash-danger.svg').default,
  GreySend: require('../assets/images/send-grey.svg').default,
  SH_Shield: require('../assets/images/shield-check.svg').default,
  SH_ShieldBlueXL: require('../assets/images/shield-blue-xl.svg').default,
  Bell: require('../assets/images/bell.svg').default,
  BellEnabled: require('../assets/images/bell-enabled.svg').default,
  BellDisabled: require('../assets/images/bell-disabled.svg').default,
  Headset: require('../assets/images/headset.svg').default,
  Gift: require('../assets/images/gift.svg').default,
  Help: require('../assets/images/help.svg').default,
  Apps: require('../assets/images/apps.svg').default,
  Logout: require('../assets/images/logout.svg').default,
  Cog: require('../assets/images/bx-cog.svg').default,
  Pencil: require('../assets/images/pencil.svg').default,
  Copy: require('../assets/images/copy.svg').default,
  Upload: require('../assets/images/upload.svg').default,
  UploadCloud: require('../assets/images/upload-cloud.svg').default,
  UploadCloudBlue: require('../assets/images/cloud-upload-blue.svg').default,
  ProspectBlacklistedColored: require('../assets/images/blacklist.svg').default,
  ProspectRemovedFromBlacklistColored: require('../assets/images/removed-from-blacklist.svg')
    .default,
  Export: require('../assets/images/export-icon.svg').default,
  ExportGrey: require('../assets/images/export-grey.svg').default,
  BlacklistDomain: require('../assets/images/clipboard-x.svg').default,
  FileBlank: require('../assets/images/file-blank.svg').default,
  ArrowsSort: require('../assets/images/arrows-sort.svg').default,
  InfoCircle: require('../assets/images/info-circle.svg').default,
  ArrowDown: require('../assets/images/arrow-down.svg').default,
  ArrowRight: require('../assets/images/arrow-right.svg').default,
  ArrowForward: require('../assets/images/arrow-forward.svg').default,
  SmileIcon: require('../assets/images/smile-icon.svg').default,
  MoodSmileIcon: require('../assets/images/mood-smile.svg').default,
  TemplateIcon: require('../assets/images/template-icon.svg').default,
  InfoCircleYellow: require('../assets/images/info-circle-yellow.svg').default,
  ChecksGreen: require('../assets/images/checks-green.svg').default,
  BanForUnsubscribe: require('../assets/images/ban-for-unsubscribe.svg')
    .default,
  NotificationPause: require('../assets/images/notification-pause.svg').default,
  NotificationAlert: require('../assets/images/notification-alert.svg').default,
  NotificationLeadBulkReveal: require('../assets/images/notification-bulk-reveal.svg')
    .default,
  NotificationRefresh: require('../assets/images/notification-refresh.svg')
    .default,
  NotificationUser: require('../assets/images/notification-user.svg').default,
  NoNotifications: require('../assets/images/no-notification.svg').default,
  ActiveNotificationBell: require('../assets/images/blue-bell.svg').default,
  LogoutActive: require('../assets/images/blue-logout.svg').default,
  CogActive: require('../assets/images/blue-cog.svg').default,
  HelpActive: require('../assets/images/blue-help.svg').default,
  ChevronLeftBlue: require('../assets/images/chevron-left-blue.svg').default,
  ChevronRightBlue: require('../assets/images/chevron-right-blue.svg').default,
  Peoples: require('../assets/images/peoples.svg').default,
  ProspectAdd: require('../assets/images/prospect-add.svg').default,
  Replied: require('../assets/images/replied.svg').default,
  MailBounced: require('../assets/images/mail-bounced-gray.svg').default,
  AlertCircle: require('../assets/images/alert-circle.svg').default,
  Opened: require('../assets/images/opened.svg').default,
  Clicked: require('../assets/images/clicked.svg').default,
  Unsubscribed: require('../assets/images/unsubscribed.svg').default,
  Calendar: require('../assets/images/calendar.svg').default,
  Mail: require('../assets/images/mail.svg').default,
  Loader: require('../assets/images/loader.svg').default,
  User: require('../assets/images/user.svg').default,
  WalletBlue: require('../assets/images/wallet-blue.svg').default,
  EmptyShield: require('../assets/images/blank-shield.svg').default,
  AlertCircleRed: require('../assets/images/alert-circle-red.svg').default,
  UserCheck: require('../assets/images/user-check.svg').default,
  UserExcremental: require('../assets/images/user-exclamation.svg').default,
  RefreshBlue: require('../assets/images/refresh-blue.svg').default,
  AlertCircleBlue: require('../assets/images/info-circle-blue.svg').default,
  Lock: require('../assets/images/lock.svg').default,
  ChevronLeft: require('../assets/images/chevron-left.svg').default,
  YoutubeLogo: require('../assets/images/youtube.svg').default,
  InfoCircleRed: require('../assets/images/info-circle-red.svg').default,
  ChevronDown: require('../assets/images/chevron-down.svg').default,
  CheckGreen: require('../assets/images/check.svg').default,
  CheckSingleGreen: require('../assets/images/check-single-green.svg').default,
  CheckSingleOrange: require('../assets/images/check-orange.svg').default,
  AlertCircleOrange: require('../assets/images/alert-circle-orange.svg')
    .default,
  Cross: require('../assets/images/cross.svg').default,
  CrossRed: require('../assets/images/cross-red.svg').default,
  CrossGray: require('../assets/images/cross-gray.svg').default,
  Refresh: require('../assets/images/refresh.svg').default,
  RefreshGrey: require('../assets/images/refresh-grey.svg').default,
  SmartIdeas: require('../assets/images/smart-ideas.svg').default,
  Server: require('../assets/images/server.svg').default,
  // Gmail: require('../assets/images/gmail.svg').default,
  Microsoft: require('../assets/images/microsoft.svg').default,
  Youtube: require('../assets/images/youtube.svg').default,
  ExternalLinkIcon: require('../assets/images/external-link.svg').default,
  ExternalLinkWhite: require('../assets/images/external-link-white.svg')
    .default,
  BanMedium: require('../assets/images/ban-m.svg').default,
  ServerBlue: require('../assets/images/server-blue.svg').default,
  MailSend: require('../assets/images/mail-send.svg').default,
  UserList: require('../assets/images/user-list.svg').default,
  TrashSmall: require('../assets/images/trash-small.svg').default,
  OpenedDisabled: require('../assets/images/opened-disabled.svg').default,
  OpenedEnabled: require('../assets/images/opened-enabled.svg').default,
  OpenedBlue: require('../assets/images/opened-blue.svg').default,
  ClickedDisabled: require('../assets/images/clicked-disabled.svg').default,
  ClickedEnabled: require('../assets/images/clicked-enabled.svg').default,
  ClickedBlue: require('../assets/images/clicked-blue.svg').default,
  OpenedWithBg: require('../assets/images/opened-bg.svg').default,
  ClickedWithBg: require('../assets/images/clicked-bg.svg').default,
  LinkChain: require('../assets/images/link-chain.svg').default,
  Mailbox: require('../assets/images/mailbox.svg').default,
  NoResult: require('../assets/images/no-result.svg').default,
  ChromeLight: require('../assets/images/chrome-light.svg').default,
  ChromeDark: require('../assets/images/chrome-dark.svg').default,
  ChromeGrey: require('../assets/images/chrome-gray.svg').default,
  ChromeBlue: require('../assets/images/chrome-blue.svg').default,
  PlayCircle: require('../assets/images/play-circle.svg').default,
  GooglePlus: require('../assets/images/google-plus.svg').default,
  MicrosoftSM: require('../assets/images/microsoft-sm.svg').default,
  FavIcon: require('../assets/images/favicon.ico').default,
  Setting: require('../assets/images/setting.svg').default,
  TrendingUp: require('../assets/images/trending-up.svg').default,
  TrendingDown: require('../assets/images/trending-down.svg').default,
  PieChart: require('../assets/images/chart-pie.svg').default,
  Email: require('../assets/images/email.svg').default,
  ChevronRight: require('../assets/images/chevron-right.svg').default,
  EmptyPie: require('../assets/images/empty-pie.svg').default,
  // Broken: require('../assets/images/broken.svg').default,
  Google30x30: require('../assets/images/google-30x30.svg').default,
  Microsoft30x30: require('../assets/images/microsoft-30x30.svg').default,
  Server30x30: require('../assets/images/server-30x30.svg').default,
  Ellipse1: require('../assets/images/ellips-1.svg').default,
  Ellipse2: require('../assets/images/ellips-2.svg').default,
  Ellipse3: require('../assets/images/ellips-3.svg').default,
  Ellipse4: require('../assets/images/ellips-4.svg').default,
  HalfCircle: require('../assets/images/half-circle.svg').default,
  Friends: require('../assets/images/friends.svg').default,
  FriendsBlue: require('../assets/images/friends-blue.svg').default,
  NoEmailsFound: require('../assets/images/no-email-found.svg').default,
  Popper: require('../assets/images/popper.svg').default,
  Messages: require('../assets/images/messages.svg').default,
  Default: require('../assets/images/default.svg').default,
  Image: require('../assets/images/image.svg').default,
  Zip: require('../assets/images/zip.svg').default,
  Pdf: require('../assets/images/pdf.svg').default,
  Video: require('../assets/images/video.svg').default,
  Ppt: require('../assets/images/ppt.svg').default,
  Sheets: require('../assets/images/sheets.svg').default,
  Docs: require('../assets/images/docs.svg').default,
  Rotate: require('../assets/images/rotate.svg').default,
  Star: require('../assets/images/star.svg').default,
  MagicWand: require('../assets/images/magic-wand.svg').default,
  Discount: require('../assets/images/discount.svg').default,
  PaperPlane: require('../assets/images/paper-plane.svg').default,
  PausedWithBackground: require('../assets/images/paused-with-bg.svg').default,
  ResumeWithBackground: require('../assets/images/resume-with-bg.svg').default,
  SearchingEmpty: require('../assets/images/searching-empty.svg').default,
  CircleCheckGreen: require('../assets/images/circle-check-green.svg').default,
  AlertTriangleOrange: require('../assets/images/alert-triangle-orange.svg')
    .default,
  InProgress: require('../assets/images/in-progress.svg').default,
  FolderOpen: require('../assets/images/folder-open.svg').default,
  PremiumFeature: require('../assets/images/premium-feature.svg').default,
  AccessDenied: require('../assets/images/access-denied.svg').default,
  CreateNewEmail: require('../assets/images/email-accounts/Create_New_Email_Icon.svg')
    .default,
  EmailConfiguration: require('../assets/images/email-accounts/Email_Configuration_Icon.svg')
    .default,
  EmptyListSearchDomain: require('../assets/images/email-accounts/Empty-List-Search-Domain_Icon.svg')
    .default,
  NoDomainSearchResult: require('../assets/images/email-accounts/NO_DOMAIN_SEARCH_RESULT_ICON.svg')
    .default,
  NoEmailFound: require('../assets/images/email-accounts/NO_EMAIL_FOUND_ICON.svg')
    .default,
  NoGenderAvatar: require('../assets/images/email-accounts/No_Gender_Avatar.svg')
    .default,
  MicrosoftDisabled: require('../assets/images/email-accounts/microsoft-disabled.svg')
    .default,
  MaildosoDisabled: require('../assets/images/email-accounts/maildoso-disabled.svg')
    .default,
  MailDoso30x30: require('../assets/images/email-accounts/maildoso-30x30.svg')
    .default,
  Maildoso: require('../assets/images/email-accounts/maildoso.png').default,
  UnsubscribeEmailHeaderPreview: require('../assets/images/unsubscribe-email-header-preview.png')
    .default,
  MaildosoSquare: require('../assets/images/email-accounts/maildoso-square.png')
    .default,
  InfraMail16x16: require('../assets/images/email-accounts/inframail-16x16.svg')
    .default,
  InfraMail30x30: require('../assets/images/email-accounts/inframail-30x30.svg')
    .default,
  Pipedrive: require('../assets/images/Pipedrive.svg').default,
  Zoho: require('../assets/images/zoho.svg').default,
  Hubspot: require('../assets/images/Hubspot.svg').default,
  Salesforce: require('../assets/images/salesforce.svg').default,
  SwitchHorizontal: require('../assets/images/switch-horizontal.svg').default,
  // AgencyPortal: require('../assets/images/agency-portal.svg').default,
  ArrowUpCircle: require('../assets/images/arrow-up-circle.svg').default,
  // Testimonial1: require('../assets/images/testimonials/1.jpeg').default,
  // Testimonial2: require('../assets/images/testimonials/2.jpeg').default,
  // Testimonial3: require('../assets/images/testimonials/3.jpeg').default,
  Testimonial4: require('../assets/images/testimonials/4.png').default,
  Testimonial2Bg: require('../assets/images/testimonials/2-bg.png').default,
  Testimonial3Bg: require('../assets/images/testimonials/3-bg.png').default,
  Testimonial4Bg: require('../assets/images/testimonials/4-bg.png').default,
  Rocket: require('../assets/images/rocket.svg').default,
  UserWithBg: require('../assets/images/user-with-bg.svg').default,
  TeamsUI: require('../assets/images/teams-ui.svg').default,
  PartyHorn: require('../assets/images/party-horn.svg').default,
  EmailSend: require('../assets/images/mail-send.svg').default,
  EmailSendYellow: require('../assets/images/mail-send-yellow.svg').default,
  BxDollarGreen: require('../assets/images/bx-dollar-green.svg').default,
  BxDollarGray: require('../assets/images/bx-dollar-gray.svg').default,
  GripVertical: require('../assets/images/grip-vertical.svg').default,
  EllipseGreen: require('../assets/images/ellipse-green.svg').default,
  EllipsePurple: require('../assets/images/ellipse-purple.svg').default,
  PauseCircle: require('../assets/images/pause-circle.svg').default,
  ZapierLogo: require('../assets/images/zapier-logo.svg').default,
  SendlerLogo: require('../assets/images/sendler-logo.svg').default,
  PichlaneLogo: require('../assets/images/pichlane-log.svg').default,
  SendsparkLogo: require('../assets/images/sendspark-logo.svg').default,
  WeezlyLogo: require('../assets/images/weezly-log.svg').default,
  CircleCheck: require('../assets/images/circle-check-green.svg').default,
  SpintaxGray: require('../assets/images/spintax-gray.svg').default,
  SpintaxBlack: require('../assets/images/spintax-black.svg').default,
  Quotes: require('../assets/images/quotes.svg').default,
  VerifiedFalse: require('./svg/verified-false.svg').default,
  VerifiedTrue: require('./svg/verified-true.svg').default,
  VerifiedError: require('./svg/verified-error.svg').default,
  LogoCompanyName: require('./svg/whitelabel-logo.svg').default,
  WhitelabelFavicon: require('./svg/whitelabel-favicon.svg').default,
  ShLogoBlue: require('../assets/images/sh-logo-blue.svg').default,
  BxRightArrow: require('../assets/images/bx-right-arrow.svg').default,
  Stars: require('../assets/images/stars.svg').default,
  EmailSubsequence: require('../assets/images/subsequences/subsequences-empty.svg')
    .default,
  RocketColor: require('../assets/images/rocket-color.svg').default,
  HeartColor: require('../assets/images/heart-color.svg').default,
  StarColor: require('../assets/images/star-color.svg').default,
  BuildingColor: require('../assets/images/building-color.svg').default,
  G2Logo: require('../assets/images/g2-logo.svg').default,
  G2Rating: require('../assets/images/upgrade-plan/g2-rating.svg').default,
  // G2Achievement: require('../assets/images/upgrade-plan/g2-achievement.svg')
  // .default,
  // Certificates: require('../assets/images/upgrade-plan/certificates.svg')
  // .default,
  GooglePlayQR: require('../assets/images/google-play-store-qr.svg').default,
  AppleAppStoreQR: require('../assets/images/apple-app-store-qr.svg').default,
  FollowUpStep: require('../assets/images/subsequences/followup-step.svg')
    .default,
  ProspectIllustration: require('../assets/images/subsequences/prospect-illustration.svg')
    .default,
  NoResultGradient: require('../assets/images/no-result-gradient.svg').default,
  SearchGrey: require('../assets/images/search-grey.svg').default,
  GroupSearch: require('../assets/images/group-search.svg').default,
  ApplySearch: require('../assets/images/apply-search.svg').default,
  ExternalLinkBlue: require('../assets/images/extrenal-link-blue.svg').default,
  SlackIcon: require('../assets/images/icons/slack.svg').default,
  EmailVerified: require('../assets/images/email-verified.svg').default,
  Recurring: require('../assets/images/recurring.svg').default,
  ManualSequence: require('../assets/images/manual-sequence.svg').default,
  ManualExternal: require('../assets/images/manual-external.svg').default,
  NoResultInboxRadar: require('../assets/images/no-result-inbox-radar.svg')
    .default,
  NoTestFound: require('../assets/images/no-test-found.svg').default,
  WaitingForEmail: require('../assets/images/waiting-for-email.svg').default,
  EmailNotReceived: require('../assets/images/email-not-received.svg').default,
  Outlook: require('../assets/images/outlook.svg').default,
  Yahoo: require('../assets/images/yahoo.svg').default,
  Exchange: require('../assets/images/exchange.svg').default,
  Globe: require('../assets/images/globe.svg').default,
  Plus: require('../assets/images/plus.svg').default,
  // yourCompanyWebsite: require('../assets/images/your-company-website.svg')
  //   .default,
  // CompanyOverview: require('../assets/images/company-overview.svg').default,
  // PrimaryCampaignGoal: require('../assets/images/primary-campaign-goal.svg')
  //   .default,
  // KeyServiceProduct: require('../assets/images/key-service-product.svg')
  //   .default,
  // SequenceSteps: require('../assets/images/sequence-steps.svg').default,
  // AiSequenceGenerate: require('../assets/images/ai-generate-sequence.svg')
  //   .default,
  BulbBlue: require('../assets/images/bulb-blue.svg').default,
  StarsWhite: require('../assets/images/stars-white.svg').default,
  RefreshWhite: require('../assets/images/refresh-white.svg').default,
  MultichannelTask: require('../assets/images/multichannel-task.svg').default,
  EmailVerifierSuccess: require('../assets/images/email-verifier-success.svg')
    .default,
  InvalidCircle: require('../assets/images/invalid-circle.svg').default,
  EmailVerifier: require('../assets/images/email-verifier.svg').default,
  OpenAI: require('../assets/images/open-ai.svg').default,
  Perplexity: require('../assets/images/perplexity.svg').default,
  Gemini: require('../assets/images/gemini.svg').default,
  Anthropic: require('../assets/images/claude-ai.svg').default,
  AiCredits: require('../assets/images/ai-credits.svg').default,
  Notes: require('../assets/images/notes.svg').default,
  ExistingProspects: require('../assets/images/ai-columns/existing-prospect.svg')
    .default,
  OwnPrompt: require('../assets/images/ai-columns/own-prompt.svg').default,
  UseTemplate: require('../assets/images/ai-columns/use-template.svg').default,
  Bullet: require('../assets/images/bullet.svg').default,
  NumberList: require('../assets/images/numbers.svg').default,
  UpperCase: require('../assets/images/upper-case.svg').default,
  LowerCase: require('../assets/images/lower-case.svg').default,
  ShortParagraph: require('../assets/images/short-para.svg').default,
  Device: require('../assets/images/device-floppy.svg').default,
  StarEyeEmoji: require('../assets/images/star-eye-emoji.svg').default,
  TearFaceEmoji: require('../assets/images/tear-face-emoji.svg').default,
  SadFaceEmoji: require('../assets/images/sad-face-emoji.svg').default,
  MergeTag: require('../assets/images/merge-tag.svg').default,
  GlobeBlue: require('../assets/images/globe-blue.svg').default,
  ArrowRightGradient: require('../assets/images/arrow-right-gradient.svg')
    .default,
  NoResultAiColumns: require('../assets/images/no-result-ai-columns.svg')
    .default,
  LongParagraph: require('../assets/images/long-paragraph.svg').default,
  HTML: require('../assets/images/html.svg').default,
  Defaultvalue: require('../assets/images/default-value.svg').default,
  Comma: require('../assets/images/comma.svg').default,
  SingleSentence: require('../assets/images/single-sentence.svg').default,
  ArrowRightNewGradient: require('../assets/images/arrow-right-new-gradient.svg')
    .default,
  Play: require('../assets/images/play2.svg').default,
  AiColumnsSuccess: require('../assets/images/aiColumn-success.svg').default,
  AiColumnsFailed: require('../assets/images/ai-col-failed.svg').default,
  AiStarGreyBorder: require('../assets/images/ai-star-grey-border.svg').default,
  Chatbox: require('../assets/images/chatbox.svg').default,
  EditStar: require('../assets/images/edit-star.svg').default,
  EditStarGradient: require('../assets/images/edit-star-gradient.svg').default,
  Stop: require('../assets/images/stop.svg').default,
  StopRed: require('../assets/images/stop-red.svg').default,
  Grok: require('../assets/images/grok.svg').default,
  AiColStar: require('../assets/images/ai-col-star.svg').default,
  AiColStarGradient: require('../assets/images/ai-col-star-gradient.svg')
    .default,
  InfoCircleDown: require('../assets/images/info-circle-down.svg').default,
  UseTemplateToEnrich: require('../assets/images/ai-columns/use-template-to-enrich.svg')
    .default,
  WriteOwnPrompt: require('../assets/images/ai-columns/write-own-prompt.svg')
    .default,
  UnsubscribeBan: require('../assets/images/unsubscribe-ban.svg').default,
  MarkAsFinishedFlag: require('../assets/images/mark-as-finished-flag.svg')
    .default,
  RepliedArrowBackUp: require('../assets/images/replied-arrow-back-up.svg')
    .default,
  SequencePausedCircle: require('../assets/images/sequence-paused-circle.svg')
    .default,
  ResumedSequencePlay: require('../assets/images/resumed-sequence-play.svg')
    .default,
  PrimaryEmailNumberExchange: require('../assets/images/primary-email-number-exchange.svg')
    .default,
  ColumnFilter: require('../assets/images/column-filter.svg').default,
  DeleteActionFilter: require('../assets/images/delete-action-trash.svg')
    .default,
  SystemUpdateSettings: require('../assets/images/system-update-settings.svg')
    .default,
  MarkAsBounced: require('../assets/images/mark-as-bounced.svg').default,
  Note: require('../assets/images/note-orange.svg').default,
  EditNote: require('../assets/images/edit-note.svg').default,
  CallOutgoing: require('../assets/images/call-outgoing.svg').default,
  CallOutcomeSignal: require('../assets/images/call-outcome-signal.svg')
    .default,
  PurpleSend: require('../assets/images/purple-send.svg').default,
  Linkedin: require('../assets/images/linkedin.svg').default,
  PurpleColorSignal: require('../assets/images/purple-color-signal.svg')
    .default,
  Whatsapp: require('../assets/images/whatsapp.svg').default,
  OrangeTaskCheckbox: require('../assets/images/orange-task-checkbox.svg')
    .default,
  GrayColorAlarm: require('../assets/images/gray-color-alarm.svg').default,
  TaskSkipped: require('../assets/images/task-skipped.svg').default,
  GreenCircleCheck: require('../assets/images/green-circle-check.svg').default,
  PhoneCross: require('../assets/images/phone-cross.svg').default,
  CallIncoming: require('../assets/images/call-incoming.svg').default,
  BlueUserList: require('../assets/images/blue-user-list.svg').default,
  UserPlus: require('../assets/images/user-plus.svg').default,
  ClickedLink: require('../assets/images/clicked-link.svg').default,
  EmailVerifierShield: require('../assets/images/email-verifier-sheild.svg')
    .default,
  BadEmailVerifier: require('../assets/images/bad-email-verifier.svg').default,
  SendBlue: require('../assets/images/send-blue.svg').default,
  BlacklistedRed: require('../assets/images/blacklisted-red.svg').default,
  BlacklistedBlue: require('../assets/images/blacklisted-blue.svg').default,
  Public: require('../assets/images/lock-open.svg').default,
  Private: require('../assets/images/lock-private.svg').default,
  Call: require('../assets/images/call.svg').default,
  NoteGrey: require('../assets/images/note-grey.svg').default,
  NoteOrange: require('../assets/images/note-orange.svg').default,
  Tasks: require('../assets/images/tasks.svg').default,
  ErrorChip: require('../assets/images/error-chip.svg').default,
  ChipCancel: require('../assets/images/chip-cancel.svg').default,
  USAFlag: require('../assets/images/dialer/usa-flag.png').default,
  UKFlag: require('../assets/images/dialer/uk-flag.png').default,
  FranceFlag: require('../assets/images/dialer/france-flag.png').default,
  GermanyFlag: require('../assets/images/dialer/germany-flag.png').default,
  BelgiumFlag: require('../assets/images/dialer/belgium-flag.png').default,
  CanadaFlag: require('../assets/images/dialer/canada-flag.svg').default,
  DialerCallLogsEmpty: require('../assets/images/dialer/call-logs-empty.svg')
    .default,
  DialerVoicemailTemplatesEmpty: require('../assets/images/dialer/voicemail-templates-empty.svg')
    .default,
  DialerReportsEmpty: require('../assets/images/dialer/reports-empty.svg')
    .default,
  HideEye: require('../assets/images/hide.svg').default,
  KanbanCategoryEdit: require('../assets/images/kanban-edit.svg').default,
  ListViewIcon: require('../assets/images/list-view.svg').default,
  KanbanViewIcon: require('../assets/images/kanban-view.svg').default,
  ChecklistIcon: require('../assets/images/Prospect-Illustration.svg').default,
  LockOpenGreen: require('../assets/images/lock-open-green.svg').default,
  LockGolden: require('../assets/images/lock-golden.svg').default,
  TwitterNewBlackWhite: require('../assets/images/twitter-new-black-white.svg')
    .default,
  ReplyAllGrey: require('../assets/images/reply-all-final.svg').default,
  UnpinGrey: require('../assets/images/unpin-grey.svg').default,
  PinBlue: require('../assets/images/pin-blue.svg').default,
  ColorPalette: require('../assets/images/color-palette.svg').default,
  NoProspectSequence: require('../assets/images/no-prospect-sequence.svg')
    .default,
  NoProspectEmail: require('../assets/images/no-prospect-email.svg').default,
  NoProspectTask: require('../assets/images/no-prospect-task.svg').default,
  NoProspectNote: require('../assets/images/no-prospect-note.svg').default,
  NoProspectActivity: require('../assets/images/no-prospect-activity.svg')
    .default,
  NoteMention: require('../assets/images/note-mention.svg').default,
  PlayBlue: require('../assets/images/play-blue.svg').default,
  BluePlay: require('../assets/images/play.svg').default,
  PreWarmedMailbox: require('../assets/images/pre-warmed-mailbox.svg').default,
  EnrichFile: require('../assets/images/enrich-file.svg').default,
  NoResultCallLogs: require('../assets/images/dialer/no-search-result.svg')
    .default,
};
